import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../api/baseUrl";
import TreatmentDrop from "./TreatmentDrop";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
type FormDataType = {
  treatmentkey: number;
  treatment: string;
  treatments: string;
  treatmentId: string;
  type: string;
  types: string;
  typeId: string;
  subtype: string;
  subtypes: string;
  subtypeId: string;
  toothNos: string;
  toothNo: string;
  prices: number;
  price: number;
  description: string;
  createdAt: Date;
  quantity: number;
  note: string;
  surface: string;
  status: string;
  didBy?: string; // Make didBy optional
};
function InvoiceTreatment({
  setaddTreatmentOpent,
  settreatment,
  treatment,
  doctorid,
  addToTreatment,
}: any) {
  const { ID } = useParams();
  const [openOther, setopenOther] = useState(false);
  const [otherserror, setotherserror] = useState(false);
  const [data, setData] = useState([]);

  const initialFormData: FormDataType = {
    treatmentkey: treatment.length + 1,
    treatment: "",
    treatments: "",
    treatmentId: "",
    type: "",
    types: "",
    typeId: "",
    status: "Complete",
    subtype: "",
    subtypes: "",
    subtypeId: "",
    toothNos: "",
    toothNo: "",
    prices: 0,
    price: 0,
    description: "",
    createdAt: new Date(),
    quantity: 1,
    note: "",
    surface: "",
  };

  // Conditionally add didBy field if doctorid is present
  if (!ID) {
    (initialFormData as FormDataType).didBy = doctorid;
  }
  const [formData, setformData] = useState(initialFormData);
  const dispatch = useDispatch();
  useEffect(() => {
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        console.log(response.data.data);
        setData(response.data.data.filter((item: any) => item.status1 === true));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const onchange = (e: any) => {
    const { value, name } = e.target;
    if (name === "treatments") {
      const isOthersFromApi =
        value &&
        (value.split("/")[1] || "").trim().toLowerCase() === "others";
      if (isOthersFromApi) {
        const separatedArray = value.split("/");
        setopenOther(true);
        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatmentId: separatedArray[0],
          treatment: separatedArray[1],
          prices: Number(separatedArray[2]) || 0,
          type: "",
          types: "",
          typeId: "",
          subtype: "",
          subtypes: "",
          subtypeId: "",
        }));
      } else {
        setopenOther(false);
        const separatedArray = value.split("/");
        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatmentId: separatedArray[0],
          treatment: separatedArray[1],
          prices: Number(separatedArray[separatedArray.length - 1]) || 0,
        }));
      }
    } else if (name === "types") {
      const separatedArray = value.split("/");
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        typeId: separatedArray[0],
        type: separatedArray[1],
        prices: separatedArray[separatedArray.length - 1],
      }));
    } else if (name === "subtypes") {
      const separatedArray = value.split("/");
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        subtypeId: separatedArray[0],
        subtype: separatedArray[1],
        prices: separatedArray[separatedArray.length - 1],
      }));
    } else if (name === "quantity") {
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        // price: formData.quantity
      }));
    } else if (name === "prices") {
      setformData((prevState) => {
        if ((prevState.treatment || "").trim().toLowerCase() !== "others") {
          return prevState;
        }
        return {
          ...prevState,
          prices: value === "" ? 0 : Number(value) || 0,
        };
      });
    } else {
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    if (ID) {
      if ((formData.treatment || "").trim().toLowerCase() === "others") {
        if (formData.description !== "" && formData.prices > 0) {
          dispatch(setloadeActive());

          baseUrl
            .post(
              "treatment/add-treatments",
              {
                ...formData,
                treatment: formData.description,
                price: formData.prices * formData.quantity,
              },
              {
                headers: {
                  treatmentid: ID,
                },
              }
            )
            .then(() => {
              dispatch(setloadeDeactive());
              setaddTreatmentOpent(false);
              addToTreatment();
            })
            .catch((error) => {
              dispatch(setloadeDeactive());

              console.log(error);
            });
        } else {
          setotherserror(true);
        }
      } else {
        const price = formData.prices * formData.quantity;
        baseUrl
          .post(
            "treatment/add-treatments",
            { ...formData, price, },
            {
              headers: {
                treatmentid: ID,
              },
            }
          )
          .then(() => {
            setaddTreatmentOpent(false);
            addToTreatment();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      if ((formData.treatment || "").trim().toLowerCase() === "others") {
        if (formData.description !== "" && formData.prices > 0) {
          settreatment([
            ...treatment,
            {
              ...formData,
              treatment: formData.description,
              price: formData.prices * formData.quantity,
            },
          ]);
          addToTreatment([
            ...treatment,
            {
              ...formData,
              treatment: formData.description,
              price: formData.prices * formData.quantity,
            },
          ]);

          setaddTreatmentOpent(false);
        } else {
          setotherserror(true);
        }
      } else {
        settreatment([
          ...treatment,
          { ...formData, price: formData.prices * formData.quantity },
        ]);
        addToTreatment([
          ...treatment,
          { ...formData, price: formData.prices * formData.quantity },
        ]);
        setaddTreatmentOpent(false);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-600 flex items-center justify-between bg-gradient-to-r from-primary to-primaryLight">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" />
            <h2 className="text-xl font-bold text-white">Add Treatment</h2>
          </div>
          <button
            onClick={() => setaddTreatmentOpent(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onsubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          <TreatmentDrop
            onChange={onchange}
            label="Select Treatment"
            name="treatments"
            data={data}
          />

          {(formData.treatment || "").trim().toLowerCase() !== "others" &&
            data
              ?.filter((item: any) => item._id === formData.treatmentId)
              ?.map((filteredItem: any) => filteredItem.type)
              ?.flat().length > 0 && (
            <TreatmentDrop
              label="Select Type"
              onChange={onchange}
              name="types"
              data={data
                ?.filter((item: any) => item._id === formData.treatmentId)
                ?.map((filteredItem: any) => filteredItem.type)
                ?.flat()}
            />
          )}

          {(formData.treatment || "").trim().toLowerCase() !== "others" &&
            data
              ?.filter((item: any) => item._id === formData.treatmentId)
              .map((filteredItem: any) => filteredItem.type)
              ?.flat()
              ?.filter((item: any) => item._id === formData.typeId)
              .map((filteredItem: any) => filteredItem.subType)
              ?.flat().length > 0 && (
            <TreatmentDrop
              onChange={onchange}
              label="Select Subtype"
              name="subtypes"
              data={data
                ?.filter((item: any) => item._id === formData.treatmentId)
                .map((filteredItem: any) => filteredItem.type)
                ?.flat()
                ?.filter((item: any) => item._id === formData.typeId)
                .map((filteredItem: any) => filteredItem.subType)
                ?.flat()}
            />
          )}

          {/* Price & Quantity Row */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Price <span className="text-red-500 dark:text-red-400">*</span>
              </label>
              <input
                value={formData.prices}
                name="prices"
                type="number"
                onChange={onchange}
                disabled={!openOther}
                className={`w-full px-4 py-2.5 rounded-xl border focus:outline-none transition-all text-sm ${
                  openOther
                    ? "border-gray-600 dark:border-slate-500 bg-slate-50 dark:bg-slate-700 dark:text-slate-200"
                    : "bg-slate-100 dark:bg-slate-700/50 border-gray-600 dark:border-slate-600 text-slate-500 dark:text-slate-400 cursor-not-allowed"
                }`}
              />
              {otherserror && formData.prices <= 0 && (
                <p className="text-xs text-red-500 dark:text-red-400 mt-1">Price must be greater than 0</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Quantity</label>
              <input
                value={formData.quantity}
                name="quantity"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 focus:outline-none transition-all bg-slate-50 dark:bg-slate-700 dark:text-slate-200"
              />
            </div>
          </div>

          {/* Total Display */}
          <div className="p-3 bg-emerald-50 dark:bg-emerald-900/30 rounded-xl">
            <p className="text-sm text-emerald-700 dark:text-emerald-300">
              Total: <span className="font-bold text-lg">Rs {formData.prices * formData.quantity}</span>
            </p>
          </div>

          {/* Others Description */}
          {openOther && (
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Description <span className="text-red-500 dark:text-red-400">*</span>
              </label>
              <input
                value={formData.description}
                name="description"
                type="text"
                onChange={onchange}
                placeholder="Enter treatment description..."
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 focus:outline-none transition-all bg-slate-50 dark:bg-slate-700 dark:text-slate-200 placeholder-slate-400 dark:placeholder-slate-500"
              />
              {otherserror && formData.description === "" && (
                <p className="text-xs text-red-500 dark:text-red-400 mt-1">Description is required for custom treatments</p>
              )}
            </div>
          )}

          {/* Tooth No & Surface Row */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Tooth No</label>
              <input
                value={formData.toothNo}
                name="toothNo"
                type="number"
                onChange={onchange}
                placeholder="e.g., 11, 21"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 focus:outline-none transition-all bg-slate-50 dark:bg-slate-700 dark:text-slate-200 placeholder-slate-400 dark:placeholder-slate-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Surface</label>
              <input
                value={formData.surface}
                name="surface"
                type="text"
                onChange={onchange}
                placeholder="e.g., M, D, O"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 focus:outline-none transition-all bg-slate-50 dark:bg-slate-700 dark:text-slate-200 placeholder-slate-400 dark:placeholder-slate-500"
              />
            </div>
          </div>

          {/* Note */}
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Note</label>
            <input
              value={formData.note}
              name="note"
              type="text"
              onChange={onchange}
              placeholder="Additional notes..."
              className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 focus:outline-none transition-all bg-slate-50 dark:bg-slate-700 dark:text-slate-200 placeholder-slate-400 dark:placeholder-slate-500"
            />
          </div>

          {/* Submit Button */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={() => setaddTreatmentOpent(false)}
              className="flex-1 px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2.5 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
            >
              Add Treatment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InvoiceTreatment;
